import { css } from '@/styled-system/css';

export const calendarMonthStyles = css.raw({
  textStyle: 'body-bold',
});
